// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectUserGroup } from '@shared/utils/DirectMessages/DirectUserGroup';
export class UserGroupMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectUserGroup();
        //* 1x*/ login
        message.GroupName = fieldSet.GetValue(FieldsFactory.FIELD_NAME);
        //  id
        message.GroupId = fieldSet.GetValue(FieldsFactory.FIELD_GROUP_ID);
        // super id
        message.SuperGroupId = fieldSet.GetValue(FieldsFactory.FIELD_MASTER_ORDER_ID);
        return [message];
    }
}
